/* eslint-env es2020 */

((Drupal) => {
  const observerOptions = {
    root: null, // use the document's viewport as the container
    rootMargin: '0px', // % or px - offsets added to each side of the intersection
    threshold: 0, // percentage of the target element which is visible
  };

  const isAnimating = (element) => element.dataset.isAnimating !== undefined;
  const setIsAnimating = (element) => {
    element.dataset.isAnimating = true;
  };
  const setIsNotAnimating = (element) => {
    if (element.dataset.isAnimating !== undefined) {
      delete element.dataset.isAnimating;
    }
  };

  const observerReveal = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const revealClassGlobal = entry.target.dataset.revealClass ? 'is-in-viewport' : 'animate__animated';
      const revealClassSpecific = entry.target.dataset.revealClass ? entry.target.dataset.revealClass : `animate__${entry.target.dataset.reveal}`;
      const entryIsAnimating = isAnimating(entry.target);
      const ratio = entry.target.dataset.revealRatio ? parseFloat(entry.target.dataset.revealRatio, 10) : 0;
      if (entry.intersectionRatio > ratio) {
        if (!entryIsAnimating && (entry.target.dataset.wasAnimated === undefined || entry.target.dataset.revealMultiple !== undefined)) {
          entry.target.style.visibility = 'visible';
          entry.target.classList.add(revealClassGlobal, revealClassSpecific);
          setIsAnimating(entry.target);
          entry.target.dataset.wasAnimated = 1;
        }
        if (entry.target.dataset.revealMultiple === undefined && !!entry.target.dataset.wasAnimated) {
          observerReveal.unobserve(entry.target);
        }
      } else if (!entry.isIntersecting && !entryIsAnimating) {
        entry.target.style.visibility = 'hidden';
        entry.target.classList.remove(revealClassGlobal, revealClassSpecific);
      }
    });
  }, observerOptions);

  const observerCounter = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const countFrom = entry.target.dataset.countFrom !== undefined ? parseInt(entry.target.dataset.countFrom, 10) : 0;
      const countTo = entry.target.dataset.countTo !== undefined ? parseInt(entry.target.dataset.countTo, 10) : 0;
      const ratio = entry.target.dataset.revealRatio ? parseFloat(entry.target.dataset.revealRatio, 10) : 0;
      const entryIsAnimating = isAnimating(entry.target);
      if (entry.intersectionRatio > ratio) {
        if (!entryIsAnimating && (entry.target.dataset.wasAnimated === undefined || entry.target.dataset.countMultiple !== undefined)) {
          setIsAnimating(entry.target);
          entry.target.dataset.wasAnimated = 1;
          entry.target.innerHTML = countFrom;
          const countDurationMs = entry.target.dataset.countDurationMs !== undefined ? parseInt(entry.target.dataset.countDurationMs, 10) : 1500;
          const countSteps =
            entry.target.dataset.countSteps !== undefined
              ? parseInt(entry.target.dataset.countSteps, 10)
              : Math.min(countDurationMs / 10, countTo - countFrom);
          const countDiff = parseInt((countTo - countFrom) / countSteps, 10);
          const interval = setInterval(() => {
            let newCount = (entry.target.currentCount ? entry.target.currentCount : 0) + countDiff;
            if (newCount >= countTo) {
              newCount = countTo;
              clearInterval(interval);
              setIsNotAnimating(entry.target);
            }
            entry.target.currentCount = newCount;
            entry.target.innerHTML = newCount.toLocaleString();
          }, countDurationMs / countSteps);
        }
        if (entry.target.dataset.countMultiple === undefined && !!entry.target.dataset.wasAnimated) {
          observerReveal.unobserve(entry.target);
        }
      }
    });
  }, observerOptions);

  /**
   * Attaches the table drag behavior to tables.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attach reveal animations observers.
   */
  Drupal.behaviors.animationsReveal = {
    attach: (context) => {
      const revealables = context.querySelectorAll('[data-reveal]:not(.reveal-processed), [data-reveal-class]:not(.reveal-processed)');

      revealables.forEach((revealable) => {
        if (revealable.dataset.reveal || revealable.dataset.revealClass) {
          revealable.classList.add('reveal-processed');
          if (revealable.dataset.revealDuration) {
            revealable.style.setProperty('--animate-duration', revealable.dataset.revealDuration);
          }
          if (revealable.dataset.revealDelay) {
            revealable.style.setProperty('--animate-delay', revealable.dataset.revealDelay);
          }
          observerReveal.observe(revealable);
          const revealableSetIsNotAnimating = (e) => {
            setIsNotAnimating(e.currentTarget);
          };
          revealable.addEventListener('animationend', revealableSetIsNotAnimating);
          revealable.addEventListener('oanimationend', revealableSetIsNotAnimating);
          revealable.addEventListener('webkitAnimationEnd', revealableSetIsNotAnimating);
          revealable.addEventListener('MSAnimationEnd', revealableSetIsNotAnimating);
          revealable.addEventListener('animationcancel', revealableSetIsNotAnimating);
          revealable.addEventListener('transitionend', revealableSetIsNotAnimating);
        }
      });
    },
    // detach: (context, settings, trigger) => {},
  };

  /**
   * Attaches the table drag behavior to tables.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attach counter animations observers.
   */
  Drupal.behaviors.animationsCounter = {
    attach: (context) => {
      const countables = context.querySelectorAll('[data-count-to]:not(.counter-processed)');

      countables.forEach((countable) => {
        if (countable.dataset.countTo !== undefined) {
          const countFrom = countable.dataset.countFrom !== undefined ? parseInt(countable.dataset.countFrom, 10) : 0;
          const countTo = countable.dataset.countTo !== undefined ? parseInt(countable.dataset.countTo, 10) : 0;
          if (countTo && countFrom !== countTo) {
            observerCounter.observe(countable);
          }
        }
      });
    },
    // detach: (context, settings, trigger) => {},
  };

  // // Lax.js
  // if (window.lax) {
  //   window.lax.init();
  //   window.lax.addDriver('scrollY', () => window.scrollY, {});
  // }

  // /**
  //  * Attaches the table drag behavior to tables.
  //  *
  //  * @type {Drupal~behavior}
  //  *
  //  * @prop {Drupal~behaviorAttach} attach
  //  *   Specific description of this attach function goes here.
  //  * @prop {Drupal~behaviorDetach} detach
  //  *   Specific description of this detach function goes here.
  //  */
  //  Drupal.behaviors.rellax = {
  //   attach: () => {
  //     if (window.Rellax) {
  //       window.OP.rellax = new window.Rellax('.rellax');
  //     }
  //   },
  //   // detach: (context, settings, trigger) => {},
  // };
})(Drupal);
